import type { KnowledgeOwnerType } from '../knowledge';
import { TriggerKey } from '../userCommunicationAgent';

export interface KnowledgePageTriggerConfig {
  spaceId: string;
  ownerType: KnowledgeOwnerType;
  ownerId: string;
  parentPageId?: string;
}

export interface LoadKnowledgePageStepConfig {
  spaceId: string;
  pageId: string;
}

export const KNOWLEDGE_TRIGGER_KEYS = [TriggerKey.KNOWLEDGE_PAGE_CREATED];
